module.exports = __webpack_public_path__ + "static/media/hydrocut-logo-shadow.290283b4.png";